/**
 * normalizeErrorMessage
 * Extracts a human-readable string from any error shape (Axios, FastAPI, plain object, string).
 * Guarantees the return value is always a renderable string — never an object.
 */
export const normalizeErrorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
  if (!err) return fallback;
  if (typeof err === 'string') return err;

  // Axios error → err.response.data.detail (FastAPI pattern)
  const detail = err?.response?.data?.detail ?? err?.detail;
  if (detail) {
    if (typeof detail === 'string') return detail;
    if (typeof detail === 'object' && detail.message) return String(detail.message);
  }

  // Axios error → err.response.data.message
  const dataMsg = err?.response?.data?.message;
  if (typeof dataMsg === 'string') return dataMsg;

  // Standard Error instance
  if (typeof err.message === 'string') return err.message;

  return fallback;
};
